import React, { useEffect } from "react";
import Scrolltop from "../components/Scrolltop";
import "./terms.css";
import { Footer } from "../components/footer";
import { Upperbox } from "../components/Upperbox";
import Nav from "../components/Nav";

const Terms = () => {
  useEffect(() => {
    // Scroll to the top of the page when the component is mounted
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-background">
      <Upperbox />
      <Nav />

      {/* Terms & Conditions Section */}
      <div className="terms-aboutus-container">
        <div className="terms-aboutus-content">
          <div className="terms-aboutus-text">
            <h1 className="terms-ab-u" data-aos="fade-down">Terms & Conditions</h1>
            <p>
              These Terms and Conditions govern your use of the services and
              website provided by Sri Krishnaa Authentic Indian Cuisine. By
              accessing or using our services, you agree to comply with and be
              bound by these terms. If you do not agree, please refrain from
              using our services.
            </p>

            <h2 className="terms-title">Website Usage</h2>
            <p>
              The content on this website is intended for informational purposes
              only. We reserve the right to modify, update, or discontinue any
              part of our website or services at any time without prior notice.
              Unauthorized use of this website may give rise to a claim for
              damages or be considered a criminal offense. Users are prohibited
              from misusing the website in any way, including but not limited to
              introducing malicious code, attempting to gain unauthorized access,
              or engaging in activities that disrupt its functionality.
            </p>

            <h2 className="terms-title">Privacy Policy</h2>
            <p>
              Your privacy is important to us. All personal data collected through
              our website or services is processed in accordance with applicable
              laws, including the UK General Data Protection Regulation (UK
              GDPR). We collect only necessary information such as your name,
              contact details, and order history to ensure efficient service
              delivery. Our detailed Privacy Policy outlines how your data is
              used, stored, and safeguarded. Please review it to understand your
              rights and our practices.
            </p>

            <h2 className="terms-title">Order Policies</h2>
            <p>
              Placing an order through our website constitutes an offer to
              purchase our products. Orders are subject to availability and
              acceptance by us. Once accepted, we will send a confirmation
              email detailing your order. Modifications to confirmed orders are
              only possible within a specified time frame and may be subject to
              additional charges. Please ensure that the information you provide
              during the order process is accurate to avoid delays or issues.
            </p>

            <h2 className="terms-title">Payment</h2>
            <p>
              Payments for all orders must be made at the time of purchase. We
              accept major debit and credit cards and other secure payment
              methods displayed on our website. Payment transactions are
              encrypted to protect your financial information. It is your
              responsibility to ensure sufficient funds are available to complete
              the transaction. Any failure of payment may result in the
              cancellation of your order. Receipts for transactions are provided
              electronically for your records.
            </p>

            <h2 className="terms-title">Cancellation & Refunds</h2>
            <p>
              We understand that unforeseen circumstances may require you to
              cancel your order. Cancellations must be requested before the
              preparation of your order begins. Refunds, if applicable, will be
              processed promptly and returned to your original payment method.
              Please note that refunds may take a few days to reflect in your
              account depending on your financial institution. Refunds are not
              issued for orders already prepared or delivered, except in cases
              where there has been an error on our part.
            </p>

            <h2 className="terms-title">Delivery & Takeaway</h2>
            <p>
              Delivery services are subject to availability and the delivery
              address being within our specified range. Estimated delivery times
              are provided as a guideline and may vary due to traffic, weather,
              or other unforeseen circumstances. We are committed to delivering
              your order in the best condition, and we package all items
              securely to maintain freshness. For takeaway orders, please arrive
              promptly at the designated time to ensure optimal food quality.
              Delays in pickup may result in your order being served at a
              suboptimal temperature.
            </p>

            <h2 className="terms-title">Cookies</h2>
            <p>
              Our website uses cookies to enhance your browsing experience and
              analyze website traffic. Cookies store non-personally identifiable
              information about your interaction with our site. By continuing to
              use our site, you consent to our use of cookies as described in
              our Cookie Policy. You may disable cookies through your browser
              settings, but doing so could impact the functionality of certain
              features on our website.
            </p>

            <h2 className="terms-title">Intellectual Property</h2>
            <p>
              All content on this website, including text, images, graphics, and
              logos, is the intellectual property of Sri Krishnaa Authentic
              Indian Cuisine. Unauthorized reproduction, distribution, or
              modification of any content is strictly prohibited and may result
              in legal action. Users may download or print content solely for
              personal, non-commercial use.
            </p>

            <h2 className="terms-title">Liability</h2>
            <p>
              We strive to ensure that the information on our website is
              accurate and up-to-date. However, we make no warranties or
              guarantees regarding its completeness or accuracy. To the maximum
              extent permitted by law, we disclaim liability for any damages or
              losses resulting from your use of our website or services. This
              includes indirect, incidental, or consequential damages arising
              from errors, interruptions, or delays in service.
            </p>

            <h2 className="terms-title">Contact Us</h2>
            <p>
              If you have any questions or concerns about these Terms &
              Conditions, please do not hesitate to contact us. We value your
              feedback and are here to assist with any issues.
            </p>
            <ul>
  <li>Email: <a href="mailto:info@srikrishnaaindiancuisine.co.uk">info@srikrishnaaindiancuisine.co.uk</a></li>
  <li>Phone: +44 7554466904</li>
</ul>

          </div>
        </div>
      </div>

      <Scrolltop />
      <Footer />
    </div>
  );
};

export default Terms;
